export default __webpack_public_path__ + "static/media/Tasset of Red Ruin (nm).34fc922b.jpg";